__turbopack_context__.v({
  "backgroundImg": "homepage-module-scss-module__BQnrJa__backgroundImg",
  "bottomLine": "homepage-module-scss-module__BQnrJa__bottomLine",
  "link": "homepage-module-scss-module__BQnrJa__link",
  "pageContentWrapper": "homepage-module-scss-module__BQnrJa__pageContentWrapper",
  "pageNavigationContainer": "homepage-module-scss-module__BQnrJa__pageNavigationContainer",
  "pageTitleContainer": "homepage-module-scss-module__BQnrJa__pageTitleContainer",
});
